<template>
  <div v-if="emailSent" class="app-login-form-wrp">
    <div>Check You Email For signin Instructions Thanks.</div>
  </div>
  <div v-else-if="loading" class="app-login-form-wrp">
    <div>Authenticating...</div>
  </div>
  <div v-else-if="!networkOnLine" class="app-login-form-wrp">
    <div
      data-test="offline-instruction"
    >Please check your connection, login feature is not available offline.</div>
  </div>
  <div v-else class="app-login-form-wrp">
    <!-- Loader -->
    <div v-show="user === undefined" data-test="loader">Authenticating...</div>

    <p v-if="loginError">{{ loginError }}</p>
    <div class="single-fld">
      <i class="fas fa-user"></i>
      <input v-model="email" type="email" name="email" placeholder="Email Address" />
    </div>

    <!-- v-show="user !== undefined && !user && networkOnLine" -->
    <button data-test="login-btn" class="app-button" @click="login">Sign in</button>
    <!-- Auth UI -->
    <!-- <div
      v-show="user !== undefined && !user && networkOnLine"
      data-test="login-btn"
      class="login-btn"
      @click="login"
    >Login with google</div>-->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { isNil } from 'lodash'
import firebase from 'firebase/app'
import { desktop as isDekstop } from 'is_js'

export default {
  data: () => ({
    loginError: null,
    email: '',
    emailSent: false,
    loading: false
  }),
  head: function() {
    return {
      title: {
        inner: 'Login'
      },
      meta: [
        {
          name: 'description',
          content: `Sign in or sign up to ${this.appTitle}`,
          id: 'desc'
        }
      ]
    }
  },
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('app', ['networkOnLine', 'appTitle'])
  },
  watch: {
    user: {
      handler(user) {
        if (!isNil(user)) {
          const redirectUrl = isNil(this.$route.query.redirectUrl)
            ? '/check-login'
            : this.$route.query.redirectUrl
          this.$router.push(redirectUrl)
        }
      },
      immediate: true
    }
  },
  mounted() {
    // // Confirm the link is a sign-in with email link.
    // if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
    //   this.loading = true
    //   // Additional state parameters can also be passed via URL.
    //   // This can be used to continue the user's intended action before triggering
    //   // the sign-in operation.
    //   // Get the email if available. This should be available if the user completes
    //   // the flow on the same device where they started it.
    //   var email = window.localStorage.getItem('emailForSignIn')
    //   if (!email) {
    //     // User opened the link on a different device. To prevent session fixation
    //     // attacks, ask the user to provide the associated email again. For example:
    //     email = window.prompt('Please provide your email for confirmation')
    //   }
    //   // The client SDK will parse the code from the link for you.
    //   firebase
    //     .auth()
    //     .signInWithEmailLink(email, window.location.href)
    //     .then(result => {
    //       this.loading = false
    //       // Clear email from storage.
    //       // window.localStorage.removeItem('emailForSignIn')
    //       // You can access the new user via result.user
    //       // Additional user info profile not available via:
    //       // result.additionalUserInfo.profile == null
    //       // You can check if the user is new or existing:
    //       // result.additionalUserInfo.isNewUser
    //     })
    //     .catch((error) => {
    //       this.loginError = error
    //     })
    // }
  },
  methods: {
    ...mapMutations('authentication', ['setUser']),
    validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    async login() {
      this.loginError = null
      this.setUser(undefined)
      try {
        if (!this.email) throw new Error('Email Must not be empty!')
        if (!this.validateEmail(this.email)) throw new Error('Email is not valid!')
        window.localStorage.setItem('emailForSignIn', this.email)
        await firebase.auth().signInAnonymously()
        // this.emailSent = true
      } catch (err) {
        this.loginError = err
        this.setUser(null)
      }
    }
  }
}
</script>